import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes'
})
export class ArrayIncludesPipe implements PipeTransform {
  transform<T = any>(value: T, arr: T[] = []) { return arr?.includes(value)}
}
